module.exports = __webpack_public_path__ + "img/screen06.59506c11.jpg";